var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alert)?_c('v-alert',{attrs:{"transition":"scroll-y-transition","type":_vm.alert.type,"dismissible":""}},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }